// Applies variant.metafields.product.discount to every Rebuy widget's rendered price.
// Mirrors the per-widget "Custom JavaScript" snippet used in the Rebuy admin, so this
// runs site-wide instead of being pasted into ~8 separate widget configs.
// Rebuy caches variant.metafields.product.discount on its own schedule, so it can be stale.
// Fetches the metafield straight from Liquid (never cached) instead of using widget.data's copy.
// Mutates variant.price directly — that's the field Rebuy's templates read to display price.
(function () {
  var liveCache = {};

  function fetchLive(handle) {
    if (!liveCache[handle]) {
      liveCache[handle] = fetch('/products/' + handle + '?view=rebuy-pricing')
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });
    }
    return liveCache[handle];
  }

  function applyRate(variant, rate) {
    if (!(rate > 0)) return;
    if (!variant._original_price) {
      variant._original_price = variant.price;
    }
    if (!variant.compare_at_price) {
      variant.compare_at_price = variant._original_price;
    }
    variant.price = Math.round(variant._original_price * (1 - rate) * 100);
  }

  function applyDiscounts(widget) {
    var products = (widget && widget.data && widget.data.products) || [];
    return Promise.all(products.map(function (product) {
      if (!product.handle) return;
      return fetchLive(product.handle).then(function (live) {
        (product.variants || []).forEach(function (variant) {
          var liveVariant = live && (live.variants || []).find(function (v) {
            return String(v.id) === String(variant.id);
          });
          if (!liveVariant) return;
          applyRate(variant, parseFloat(liveVariant.discount) / 100);
        });
      });
    }));
  }

  function handleWidgetEvent(event) {
    var widget = event.detail && event.detail.widget;
    if (widget) applyDiscounts(widget);
  }

  document.addEventListener('rebuy.init', handleWidgetEvent);
  document.addEventListener('rebuy.beforeReady', handleWidgetEvent);

  // Rebuy dispatches 'rebuy:cart.add' on the document when its own widget adds to cart.
  // (rebuy:cart.change also fires on Rebuy's page-load cart sync, not just real adds —
  // listening to that instead opened the cart drawer on every page refresh.)
  document.addEventListener('rebuy:cart.add', function () {
    window.cartContextRef?.fetchCart();
  });
})();
